<template>
  <div>
    <b-skeleton-table v-if="loading"  :columns="2"></b-skeleton-table>
    <b-row v-else>
      <b-col cols="6">
        <h3>Sucursales a las que pertenece el usuario</h3>
        <DataTable
          :loading="loading"
          :columns="columns_sucursales"
          :rows="sucursales"
          :perPage="10"
          :buttons=false
          :searching="false"
          :td-style-class="tdStyleClassFn"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col cols="6">
        <h3>Areas a las que pertenece el usuario</h3>
        <DataTable
          :loading="loading"
          :columns="columns_areas"
          :rows="areas"
          :perPage="10"
          :buttons=false
          :searching="false"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col cols="6">
        <h3>Formularios en los que esta asignado</h3>
        <DataTable
          :loading="loading"
          :columns="columns_formularios"
          :rows="formularios"
          :perPage="10"
          :buttons=false
          :searching="false"
          :td-style-class="tdStyleClassFn"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col v-if="categorias.length > 0" cols="6">
        <h3>Categorias en las que es administrador</h3>
        <DataTable
          :loading="loading"
          :columns="columns_categorias"
          :rows="categorias"
          :perPage="10"
          :buttons=false
          :searching="false"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col cols="6">
        <h3>Programas de sucursal en los que es administrador</h3>
        <DataTable
          :loading="loading"
          :columns="columns_programas_admin"
          :rows="programa_admin"
          :perPage="10"
          :buttons=false
          :searching="false"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col cols="6">
        <h3>Programas en los que esta asignado</h3>
        <DataTable
          :loading="loading"
          :columns="columns_programas"
          :rows="programas"
          :perPage="10"
          :buttons=false
          :searching="false"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
      <b-col v-if="$store.state.usuario.usa_organizacion == 'S'" cols="6">
        <h3>Nodos de organización en los que esta asignado</h3>
        <DataTable
          :loading="loading"
          :columns="columns_organizacion"
          :rows="organizacion"
          :perPage="10"
          :buttons=false
          :searching="false"
          clases="table-bordered nowrap">
        </DataTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {userService} from "@/services";

export default {
  props: {
    usuario:{}
  },
  data(){
    return {
      loading: true,
      nombre_usuario: null,
      categorias: null,
      formularios: [],
      sucursales: [],
      areas: [],
      programa_admin: [],
      programas:[],
      organizacion:[],
      columns_sucursales : [
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Inspector', field: 'inspector'},
        {label: 'Ejecutor', field: 'ejecutor'},
        {label: 'Administrador de sucursal', field: 'admin_sucursal'},
      ],
      columns_areas : [
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Areas', field: 'desc_area'},
      ],
      columns_formularios : [
        {label: 'Categoria', field: 'nombre_categoria'},
        {label: 'Formulario', field: 'nombre'},
        {label: 'Es inspector', field: 'inspector'},
        {label: 'Es ejecutor', field: 'ejecutor'},
      ],
      columns_categorias : [
        {label: 'Categoria', field: 'nombre_categoria'},
      ],
      columns_programas_admin : [
        {label: 'Nombre programa', field: 'nombre_programa'},
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Fecha inicio', field: 'fecha_inicio'},
        {label: 'Fecha termino', field: 'fecha_termino'},
      ],
      columns_programas : [
        {label: 'Nombre programa', field: 'nombre_programa'},
        {label: 'Fecha inicio', field: 'fecha_inicio'},
        {label: 'Fecha termino', field: 'fecha_termino'},
      ],
      columns_organizacion : [
        {label: 'Nodo', field: 'nombre_nodo'}
      ]
    }
  },
  mounted(){
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Información / Usuario ' + this.usuario.nombre_usuario+ ' / Editar');
  },
  methods: {
    cargarDatos(){
      userService.getUsuarioInformacion({
        id_cliente:this.$store.state.usuario.id_cliente,
        id_usuario:this.usuario.id_usuario
      }).then(data => {
        this.nombre_usuario = data.nombre_usuario;
        this.categorias = data.categorias;
        this.formularios = data.formularios;
        this.sucursales = data.sucursales;
        this.areas = data.areas;
        this.programa_admin = data.programa_admin;
        this.programas = data.programas;
        this.organizacion = data.organizacion;
        this.loading = false;
      });
    },
    tdStyleClassFn(row, column) {
      if(row[column.field] == 'Sí'){
        return "td-green";
      }
      if(row[column.field] == 'No'){
        return "td-red";
      }
    },
  }
}
</script>

<style scoped>
</style>
